module.exports = __webpack_public_path__ + "static/img/18018D_1_R_20200819_LC.1e9bcf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18018D_1_R_20200819_LC.png
// module id = +edr
// module chunks = 0